import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=2caa59f9&scoped=true"
import script from "./UserIcon.vue?vue&type=script&lang=ts"
export * from "./UserIcon.vue?vue&type=script&lang=ts"
import style0 from "./UserIcon.vue?vue&type=style&index=0&id=2caa59f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa59f9",
  null
  
)

export default component.exports